export enum SpargingStatus {
  Disabled = 1,
  Fixed = 2,
  Threshold = 3,
}
